import { Model } from 'modules/core/lib/mobx-rest'

export interface IVisit {
  id: number
  post_id: number
  access_id: number
  created_at: string
}

class Visit extends Model<IVisit> {
  static urlRoot() {
    return '/posts/visits'
  }
}

export default Visit
